/**
 * "Tra cứu tên miền": what a typed query checks. Plain functions with no imports so
 * `npm test` (tests/lookup.test.mjs) loads this file directly.
 */

/** TLDs offered by default (the ones customers ask about most). */
export const DEFAULT_TLDS = ['vn', 'com.vn', 'net.vn', 'com', 'net', 'org', 'io', 'asia'];

/** At most this many names per lookup (the API's limit). */
export const MAX_LOOKUP_NAMES = 50;

/** Names to check: a label across the TLDs, or a full name (its own TLD first) plus the TLDs. */
export function expandQuery(input: string, tlds: readonly string[]): string[] {
  const q = input
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/\/.*$/, '')
    .replace(/\.$/, '');
  if (!q) return [];
  const [label, ...rest] = q.split('.');
  const zones = [
    ...(rest.length ? [rest.join('.')] : []),
    ...tlds.map((t) => t.trim().toLowerCase().replace(/^\./, '')).filter(Boolean),
  ];
  return [...new Set(zones.map((z) => `${label}.${z}`))];
}

/** TLDs typed as a list separated by spaces, commas or semicolons. */
export function parseTlds(text: string): string[] {
  return text.split(/[\s,;]+/).filter(Boolean);
}
